/**
 * Add BigInt serialization support to JSON.stringify
 * This prevents "Do not know how to serialize a BigInt" errors
 */
export function enableBigIntSerialization() {
  // Add toJSON method to BigInt prototype if it doesn't exist
  if (!(BigInt.prototype as any).toJSON) {
    ;(BigInt.prototype as any).toJSON = function () {
      return Number(this)
    }
  }
}
